import { render, staticRenderFns } from "./PropostaCliente.vue?vue&type=template&id=20061ffa"
import script from "./PropostaCliente.vue?vue&type=script&lang=js"
export * from "./PropostaCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports